// // import {
// //   Box,
// //   Flex,
// //   Input,
// //   Select,
// //   Spacer,
// //   useDisclosure,
// //   useToast,
// // } from "@chakra-ui/react";
// // import { Space, Table } from "antd";
// // import axios from "axios";
// // import { get } from "lodash";
// // import { useEffect, useMemo, useState } from "react";
// // import { RiDeleteBin6Line } from "react-icons/ri";
// // import { useDispatch } from "react-redux";
// // import CasestudyDeleteConfirmation from "../modals/CasestudyDeleteConfirmation";

// // interface Props {
// //   query: string;
// // }

// // const FilterCasestudyByLinkedTable: React.FC<Props> = ({ query }) => {
// //   const toast = useToast();
// //   const dispatch = useDispatch();
// //   const searchColumns = useMemo(() => ["title"], []);
// //   const { isOpen, onOpen, onClose } = useDisclosure();
// //   const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
// //   const [categoryNames, setCategoryNames] = useState<any[]>([]);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [filteredData, setFilteredData] = useState<any[]>([]);
// //   const [categoryFilter, setCategoryFilter] = useState<string>("All");
// //   const [casestudyData, setCasestudyData] = useState<any>();
// //   const [userDetail, setUserDetail] = useState<any>("");
// //   const [showFavoritesOnly, setShowFavoritesOnly] = useState(false);
// //   const [targetevent, setTargetEvent] = useState<any>();
// //   const [loading, setloading] = useState(true);
// //   const [mainCategories, setMainCategories] = useState<any>([]);
// //   const [subCategories, setSubCategories] = useState<any>([]);
// //   const [serviceTypes, setServiceTypes] = useState<any>([]);
// //   const [selectedMainCategory, setSelectedMainCategory] = useState<string>("");
// //   const [selectedSubCategory, setSelectedSubCategory] = useState<string>("");
// //   const [selectedServiceType, setSelectedServiceType] = useState<string>("");
// //   const [linkedServicesData, setLinkedServicesData] = useState<any[]>([]);

// //   const search = (casestudy: Record<string, any>) => {
// //     return searchColumns.some((column) => {
// //       return (
// //         get(casestudy, column, "")
// //           .toString()
// //           .toLowerCase()
// //           .indexOf(searchQuery.toLowerCase()) > -1
// //       );
// //     });
// //   };

// //   const {
// //     isOpen: isViewOpen,
// //     onOpen: onViewOpen,
// //     onClose: onViewClose,
// //   } = useDisclosure();

// //   const {
// //     isOpen: isDeleteOpen,
// //     onOpen: onDeleteOpen,
// //     onClose: onDeleteClose,
// //   } = useDisclosure();

// //   const {
// //     isOpen: isUpdateOpen,
// //     onOpen: onUpdateOpen,
// //     onClose: onUpdateClose,
// //   } = useDisclosure();

// //   const {
// //     isOpen: isSlotDrawerOpen,
// //     onOpen: onSlotDrawerOpen,
// //     onClose: onSlotDrawerClose,
// //   } = useDisclosure();

// //   const handleSlotClick = (record: any) => {
// //     setTargetEvent(record);
// //     onSlotDrawerOpen();
// //   };
// //   const handleView = (record: any) => {
// //     setTargetEvent(record);
// //     onViewOpen();
// //   };

// //   const updateEvent = (record: any) => {
// //     setTargetEvent(record);
// //     onOpen();
// //   };

// //   const handleDelete = (record: any) => {
// //     setTargetEvent(record);
// //     onDeleteOpen();
// //   };

// //   useEffect(() => {
// //     const getMainCategories = async () => {
// //       try {
// //         const response = await axios.get(
// //           `${process.env.REACT_APP_BASE_URL}/admin/mainCategory`
// //         );
// //         setMainCategories(response.data);
// //         console.log("mainCategories", response.data);
// //       } catch (error) {
// //         console.log(error);
// //       }
// //     };

// //     getMainCategories();
// //   }, []);

// //   useEffect(() => {
// //     const getSubCategories = async () => {
// //       if (!selectedMainCategory) {
// //         setSubCategories([]);
// //         return;
// //       }

// //       try {
// //         const response = await axios.get(
// //           `${process.env.REACT_APP_BASE_URL}/admin/subCategory?mainCategoryId=${selectedMainCategory}`
// //         );
// //         setSubCategories(response.data);
// //         setSelectedSubCategory("");
// //         setSelectedServiceType("");
// //         setServiceTypes([]);
// //       } catch (error) {
// //         console.log(error);
// //         toast({
// //           title: "Error",
// //           description: "Failed to fetch subcategories",
// //           status: "error",
// //           duration: 3000,
// //           isClosable: true,
// //         });
// //       }
// //     };

// //     getSubCategories();
// //   }, [selectedMainCategory]);

// //   useEffect(() => {
// //     const getServiceTypes = async () => {
// //       if (!selectedSubCategory) {
// //         setServiceTypes([]);
// //         return;
// //       }

// //       try {
// //         const response = await axios.get(
// //           `${process.env.REACT_APP_BASE_URL}/admin/service?subCategoryId=${selectedSubCategory}`
// //         );
// //         setServiceTypes(response.data);

// //         setSelectedServiceType("");
// //       } catch (error) {
// //         console.log(error);
// //         toast({
// //           title: "Error",
// //           description: "Failed to fetch service types",
// //           status: "error",
// //           duration: 3000,
// //           isClosable: true,
// //         });
// //       }
// //     };

// //     getServiceTypes();
// //   }, [selectedSubCategory]);

// //   useEffect(() => {
// //     const getCategoryNames = async () => {
// //       try {
// //         const response = await axios.get(
// //           `${process.env.REACT_APP_BASE_URL}/category/names`
// //         );

// //         setCategoryNames(["All", ...response.data]);
// //       } catch (error) {
// //         console.log(error);
// //       }
// //     };

// //     getCategoryNames();
// //   }, []);

// //   const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
// //     setCategoryFilter(event.target.value);
// //   };

// //   // useEffect(() => {
// //   //   const fetchData = async () => {
// //   //     const tkn = localStorage.getItem("token");
// //   //     if (!tkn) {
// //   //       toast({
// //   //         title: "Error",
// //   //         description: "Please login to continue",
// //   //         status: "error",
// //   //         duration: 3000,
// //   //         isClosable: true,
// //   //       });
// //   //       return;
// //   //     }
// //   //     if (!categoryFilter) return;

// //   //     console.log("selectedServiceType", selectedServiceType);

// //   //     let url = `${process.env.REACT_APP_BASE_URL}/admin/service/getAllService`;

// //   //     let queryParams = [];

// //   //     if (selectedServiceType) {
// //   //       queryParams.push(`&serviceId=${selectedServiceType}`);
// //   //     }
// //   //     if (selectedMainCategory) {
// //   //       queryParams.push(`&mainCategoryId=${selectedMainCategory}`);
// //   //     }
// //   //     if (selectedSubCategory) {
// //   //       queryParams.push(`&subCategoryId=${selectedSubCategory}`);
// //   //     }

// //   //     if (queryParams.length > 0) {
// //   //       url += `?${queryParams.join("&")}`;
// //   //     }

// //   //     try {
// //   //       const response = await axios.get(url, {
// //   //         headers: {
// //   //           Authorization: `${tkn}`,
// //   //         },
// //   //       });

// //   //       console.log("Fetched casestudy successfully:", response);
// //   //       let responseData: any = response?.data;
// //   //       const transformedData = responseData?.map(
// //   //         (casestudy: any, index: number) => ({
// //   //           key: casestudy._id,
// //   //           index: index + 1,
// //   //           title: casestudy.title,
// //   //           image: `${process.env.REACT_APP_IMAGE_BASE_URL}/${casestudy.imageURL}`,
// //   //           casestudyId: casestudy.caseStydyId,
// //   //           createdDate: new Date(casestudy.createdAt).toLocaleDateString(),
// //   //           description: casestudy.description,
// //   //           subcategory: casestudy.subCategory,
// //   //           type: casestudy.type,
// //   //           isFav: casestudy.isFav,
// //   //           originalData: casestudy,
// //   //         })
// //   //       );
// //   //       const filtered = searchQuery
// //   //         ? transformedData.filter(search)
// //   //         : transformedData;

// //   //       setFilteredData(filtered);
// //   //       setloading(false);
// //   //     } catch (error: any) {
// //   //       console.error("Error fetching casestudy:", error);
// //   //       setloading(false);
// //   //       toast({
// //   //         title: "Error",
// //   //         description: "Failed to fetch case studies.",
// //   //         status: "error",
// //   //         duration: 3000,
// //   //         isClosable: true,
// //   //         position: "top-right",
// //   //       });
// //   //     }
// //   //   };

// //   //   fetchData();
// //   // }, [
// //   //   categoryFilter,
// //   //   searchQuery,
// //   //   showFavoritesOnly,
// //   //   selectedMainCategory,
// //   //   selectedSubCategory,
// //   //   selectedServiceType,
// //   // ]);

// //   useEffect(() => {
// //     const fetchData = async () => {
// //       const tkn = localStorage.getItem("token");
// //       if (!tkn) {
// //         toast({
// //           title: "Error",
// //           description: "Please login to continue",
// //           status: "error",
// //           duration: 3000,
// //           isClosable: true,
// //         });
// //         return;
// //       }

// //       let url = `${process.env.REACT_APP_BASE_URL}/admin/service/getAllService`;

// //       try {
// //         const response = await axios.get(url, {
// //           headers: {
// //             Authorization: `${tkn}`,
// //           },
// //         });

// //         setLinkedServicesData(response.data);

// //         // Transform data for display
// //         const transformedData = [];
// //         for (const service of response.data) {
// //           // If no case studies or filtering by service and this isn't the selected one
// //           if (!service.caseStudy || service.caseStudy.length === 0) {
// //             continue;
// //           }

// //           // Filter by main category if selected
// //           if (
// //             selectedMainCategory &&
// //             service.mainCategory !==
// //               getMainCategoryNameById(selectedMainCategory)
// //           ) {
// //             continue;
// //           }

// //           // Filter by sub category if selected
// //           if (
// //             selectedSubCategory &&
// //             service.subCategory !== getSubCategoryNameById(selectedSubCategory)
// //           ) {
// //             continue;
// //           }

// //           // Filter by service if selected
// //           if (selectedServiceType && service._id !== selectedServiceType) {
// //             continue;
// //           }

// //           // Add each case study as a row
// //           for (const caseStudy of service.caseStudy) {
// //             transformedData.push({
// //               key: `${service._id}-${caseStudy._id}`,
// //               serviceName: service.serviceName,
// //               title: caseStudy.title,
// //               mainCategory: service.mainCategory,
// //               subCategory: caseStudy.subCategory || service.subCategory,
// //               serviceId: service._id,
// //               caseStudyId: caseStudy._id,
// //               type: caseStudy.type,
// //               image: caseStudy.imageURL
// //                 ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${caseStudy.imageURL}`
// //                 : null,
// //             });
// //           }
// //         }

// //         const filtered = searchQuery
// //           ? transformedData.filter(search)
// //           : transformedData;

// //         setFilteredData(filtered);
// //         setloading(false);
// //       } catch (error: any) {
// //         console.error("Error fetching services:", error);
// //         setloading(false);
// //         toast({
// //           title: "Error",
// //           description: "Failed to fetch service data.",
// //           status: "error",
// //           duration: 3000,
// //           isClosable: true,
// //           position: "top-right",
// //         });
// //       }
// //     };

// //     fetchData();
// //   }, [
// //     searchQuery,
// //     selectedMainCategory,
// //     selectedSubCategory,
// //     selectedServiceType,
// //   ]);

// //   const getMainCategoryNameById = (id: string) => {
// //     const category = mainCategories.find((cat: any) => cat._id === id);
// //     return category ? category.title : "";
// //   };

// //   const getSubCategoryNameById = (id: string) => {
// //     const category = subCategories.find((cat: any) => cat._id === id);
// //     return category ? category.title : "";
// //   };

// //   const handleSearch = (value: string) => {
// //     setSearchQuery(value);
// //   };

// //   const SingleImage = ({ image }: { image: string }) => (
// //     <div
// //       style={{
// //         width: 36,
// //         height: 36,
// //         borderRadius: "50%",
// //         overflow: "hidden",
// //         backgroundColor: "white",
// //       }}
// //     >
// //       <img
// //         src={image}
// //         alt="Banner"
// //         style={{
// //           width: "100%",
// //           height: "100%",
// //           objectFit: "cover",
// //         }}
// //       />
// //     </div>
// //   );

// //   const handleUnlinkCategory = async (
// //     serviceId: string,
// //     categoryId: string
// //   ) => {
// //     const tkn = localStorage.getItem("token");
// //     if (!tkn) {
// //       toast({
// //         title: "Error",
// //         description: "Please login to continue",
// //         status: "error",
// //         duration: 3000,
// //         isClosable: true,
// //       });
// //       return;
// //     }

// //     try {
// //       await axios.delete(
// //         `${process.env.REACT_APP_BASE_URL}/admin/category/unlinkCategory?categoryId=${categoryId}&serviceId=${serviceId}`,
// //         {
// //           headers: {
// //             Authorization: `${tkn}`,
// //           },
// //         }
// //       );

// //       toast({
// //         title: "Success",
// //         description: "Case study unlinked successfully",
// //         status: "success",
// //         duration: 3000,
// //         isClosable: true,
// //         position: "top-right",
// //       });

// //       // Refresh data
// //       const updatedData = filteredData.filter(
// //         (item) =>
// //           !(item.serviceId === serviceId && item.caseStudyId === categoryId)
// //       );
// //       setFilteredData(updatedData);
// //     } catch (error) {
// //       console.error("Error unlinking case study:", error);
// //       toast({
// //         title: "Error",
// //         description: "Failed to unlink case study",
// //         status: "error",
// //         duration: 3000,
// //         isClosable: true,
// //         position: "top-right",
// //       });
// //     }
// //   };

// //   const columns = [
// //     {
// //       title: "Nos.",
// //       dataIndex: "index",
// //       width: 80,
// //       render: (_: any, __: any, index: number) => `#${index + 1}`,
// //     },

// //     {
// //       title: "Service Name",
// //       dataIndex: "servicename",
// //       width: 200,
// //     },
// //     {
// //       title: "Casestudy",
// //       dataIndex: "casestudy",
// //       width: 200,
// //       render: (_: any, record: any) => {
// //         return (
// //           <div
// //             style={{
// //               display: "flex",
// //               alignItems: "center",
// //               gap: "10px",
// //             }}
// //           >
// //             <SingleImage image={record.image} />
// //             <span>{record.title}</span>
// //           </div>
// //         );
// //       },
// //     },
// //     {
// //       title: "Main Category",
// //       dataIndex: "title",
// //       width: 150,
// //     },
// //     {
// //       title: "Sub Category",
// //       dataIndex: "subCategory",
// //       width: 150,
// //     },
// //     {
// //       title: "Actions",
// //       key: "actions",
// //       width: 150,
// //       render: (_: any, record: any) => {
// //         console.log("record", record);

// //         return (
// //           <Space size="middle">
// //             <RiDeleteBin6Line
// //               style={{
// //                 color: "#ff4d4f",
// //                 cursor: "pointer",
// //                 height: "20px",
// //                 width: "20px",
// //               }}
// //               onClick={() =>
// //                 handleDeleteCaseStudy(record.serviceId, record.caseStudyId)
// //               }
// //             />
// //           </Space>
// //         );
// //       },
// //     },
// //   ];

// //   const handleCasestudy = async (record: any) => {
// //     console.log("record", record);
// //     try {
// //       const response = await axios.get(
// //         `${process.env.REACT_APP_BASE_URL}/caseStudy/getById/${record.casestudyId}`
// //       );
// //       console.log("response", response.data);
// //       setCasestudyData(response.data);
// //       return response.data;
// //     } catch (error) {
// //       console.log(error);
// //     }
// //   };

// //   const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
// //     setSelectedRowKeys(newSelectedRowKeys);
// //   };

// //   const rowSelection = {
// //     selectedRowKeys,
// //     onChange: onSelectChange,
// //   };

// //   return (
// //     <>
// //       <div
// //         style={{
// //           width: "96vw",
// //           maxWidth: "96vw",
// //           maxHeight: "86vh",
// //           height: "86vh",
// //           top: "8vh ",
// //           left: "4vw",
// //           overflowY: "auto",
// //           position: "relative",
// //           backgroundColor: "#EEEEEE",
// //           padding: "30px",
// //         }}
// //       >
// //         <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
// //           <Flex w="full" alignItems="center" justifyContent="space-between">
// //             <Box
// //               display="flex"
// //               alignItems="center"
// //               bg="#FFF"
// //               border="1px solid #b2b2b233"
// //               borderRadius="12px"
// //               w="400px"
// //               padding="8px"
// //             >
// //               <Box
// //                 pl={2}
// //                 display="flex"
// //                 alignItems="center"
// //                 color="#9E9E9E"
// //                 fontSize="2xl"
// //               >
// //                 <img
// //                   src="/icons/searchlogo.svg"
// //                   alt="searchlogo"
// //                   style={{ height: "24px", width: "24px" }}
// //                 />
// //               </Box>

// //               <Input
// //                 id="search"
// //                 type="text"
// //                 placeholder="Search or type a command"
// //                 onChange={(e) => handleSearch(e.target.value)}
// //                 fontSize="sm"
// //                 border="none"
// //                 outline="none"
// //                 color="#757575"
// //                 _focus={{
// //                   border: "none",
// //                   outline: "none",
// //                   boxShadow: "none",
// //                 }}
// //                 bg={"transparent"}
// //                 style={{
// //                   outline: "none",
// //                   boxShadow: "none",
// //                 }}
// //               />
// //             </Box>

// //             <Spacer />

// //             <Box
// //               display={"flex"}
// //               alignItems={"center"}
// //               justifyContent={"flex-end"}
// //               marginLeft="20px"
// //             >
// //               <Select
// //                 placeholder="Select Main Category"
// //                 value={selectedMainCategory}
// //                 onChange={(e) => {
// //                   const mainCategoryId = e.target.value;
// //                   setSelectedMainCategory(mainCategoryId);
// //                 }}
// //                 bg="#FFF"
// //                 marginRight="10px"
// //               >
// //                 {mainCategories.map((category: any) => (
// //                   <option key={category._id} value={category._id}>
// //                     {category.title}
// //                   </option>
// //                 ))}
// //               </Select>
// //               <Select
// //                 placeholder="Select Sub Category"
// //                 value={selectedSubCategory}
// //                 onChange={(e) => {
// //                   const subCategoryId = e.target.value;
// //                   setSelectedSubCategory(subCategoryId);
// //                 }}
// //                 bg="#FFF"
// //                 isDisabled={!selectedMainCategory}
// //                 marginRight="10px"
// //               >
// //                 {subCategories.map((subCategory: any) => (
// //                   <option key={subCategory._id} value={subCategory._id}>
// //                     {subCategory.title}
// //                   </option>
// //                 ))}
// //               </Select>
// //               <Select
// //                 placeholder="Select Service Type"
// //                 value={selectedServiceType}
// //                 onChange={(e) => {
// //                   const serviceId = e.target.value;
// //                   setSelectedServiceType(serviceId);
// //                 }}
// //                 bg="#FFF"
// //                 isDisabled={!selectedSubCategory}
// //                 marginRight="10px"
// //               >
// //                 {serviceTypes.map((service: any) => (
// //                   <option key={service._id} value={service._id}>
// //                     {service.title}
// //                   </option>
// //                 ))}
// //               </Select>
// //             </Box>
// //           </Flex>

// //           <Spacer></Spacer>

// //           <Table
// //             rowSelection={rowSelection}
// //             columns={columns}
// //             dataSource={filteredData}
// //             scroll={{ x: "max-content" }}
// //             size="middle"
// //             style={{
// //               backgroundColor: "white",
// //               borderRadius: 6,
// //             }}
// //             pagination={{
// //               position: ["bottomRight"],
// //               pageSize: 9,
// //             }}
// //           />
// //         </div>
// //       </div>

// //       {isDeleteOpen && targetevent && (
// //         <CasestudyDeleteConfirmation
// //           isOpen
// //           bannerData={targetevent}
// //           onDeleteClose={onDeleteClose}
// //           refreshData={() => {
// //             dispatch({
// //               type: "REQUEST_MASTER_CASESTUDY",
// //               payload: {
// //                 serviceId: selectedServiceType,
// //                 type: categoryFilter,
// //               },
// //               onSuccess: (response: any) => {
// //                 console.log("Fetched casestudy successfully:", response);

// //                 const transformedData = response.data.map(
// //                   (casestudy: any, index: number) => ({
// //                     key: casestudy._id,
// //                     index: index + 1,
// //                     title: casestudy.title,
// //                     image: `${process.env.REACT_APP_IMAGE_BASE_URL}/${casestudy.imageURL}`,
// //                     casestudyId: casestudy.caseStydyId,
// //                     createdDate: new Date(
// //                       casestudy.createdAt
// //                     ).toLocaleDateString(),
// //                     description: casestudy.description,
// //                     originalData: casestudy,
// //                   })
// //                 );
// //                 const filtered = searchQuery
// //                   ? transformedData.filter(search)
// //                   : transformedData;

// //                 setFilteredData(filtered);
// //               },
// //               onError: (error: any) => {
// //                 console.error("Error fetching casestudy:", error);
// //                 toast({
// //                   title: "Error",
// //                   description: "Failed to fetch case studies.",
// //                   status: "error",
// //                   duration: 3000,
// //                   isClosable: true,
// //                   position: "top-right",
// //                 });
// //               },
// //             });
// //           }}
// //         />
// //       )}
// //     </>
// //   );
// // };

// // export default FilterCasestudyByLinkedTable;
// import {
//   Box,
//   Flex,
//   Input,
//   Select,
//   Spacer,
//   useDisclosure,
//   useToast,
// } from "@chakra-ui/react";
// import { Space, Table } from "antd";
// import axios from "axios";
// import { get } from "lodash";
// import { useEffect, useMemo, useState } from "react";
// import { RiDeleteBin6Line } from "react-icons/ri";
// import { useDispatch } from "react-redux";
// import CasestudyDeleteConfirmation from "../modals/CasestudyDeleteConfirmation";

// interface Props {
//   query: string;
// }

// const FilterCasestudyByLinkedTable: React.FC<Props> = ({ query }) => {
//   const toast = useToast();
//   const dispatch = useDispatch();
//   const searchColumns = useMemo(() => ["serviceName", "title"], []);
//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredData, setFilteredData] = useState<any[]>([]);
//   const [categoryFilter, setCategoryFilter] = useState<string>("All");
//   const [casestudyData, setCasestudyData] = useState<any>();
//   const [targetevent, setTargetEvent] = useState<any>();
//   const [loading, setloading] = useState(true);
//   const [mainCategories, setMainCategories] = useState<any>([]);
//   const [subCategories, setSubCategories] = useState<any>([]);
//   const [serviceTypes, setServiceTypes] = useState<any>([]);
//   const [selectedMainCategory, setSelectedMainCategory] = useState<string>("");
//   const [selectedSubCategory, setSelectedSubCategory] = useState<string>("");
//   const [selectedServiceType, setSelectedServiceType] = useState<string>("");
//   const [linkedServicesData, setLinkedServicesData] = useState<any[]>([]);

//   const search = (item: Record<string, any>) => {
//     return searchColumns.some((column) => {
//       return (
//         get(item, column, "")
//           .toString()
//           .toLowerCase()
//           .indexOf(searchQuery.toLowerCase()) > -1
//       );
//     });
//   };

//   const {
//     isOpen: isDeleteOpen,
//     onOpen: onDeleteOpen,
//     onClose: onDeleteClose,
//   } = useDisclosure();

//   useEffect(() => {
//     const getMainCategories = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_BASE_URL}/admin/mainCategory`
//         );
//         setMainCategories(response.data);
//       } catch (error) {
//         console.log(error);
//       }
//     };

//     getMainCategories();
//   }, []);

//   useEffect(() => {
//     const getSubCategories = async () => {
//       if (!selectedMainCategory) {
//         setSubCategories([]);
//         return;
//       }

//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_BASE_URL}/admin/subCategory?mainCategoryId=${selectedMainCategory}`
//         );
//         setSubCategories(response.data);
//         setSelectedSubCategory("");
//         setSelectedServiceType("");
//         setServiceTypes([]);
//       } catch (error) {
//         console.log(error);
//         toast({
//           title: "Error",
//           description: "Failed to fetch subcategories",
//           status: "error",
//           duration: 3000,
//           isClosable: true,
//         });
//       }
//     };

//     getSubCategories();
//   }, [selectedMainCategory]);

//   useEffect(() => {
//     const getServiceTypes = async () => {
//       if (!selectedSubCategory) {
//         setServiceTypes([]);
//         return;
//       }

//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_BASE_URL}/admin/service?subCategoryId=${selectedSubCategory}`
//         );
//         setServiceTypes(response.data);
//         setSelectedServiceType("");
//       } catch (error) {
//         console.log(error);
//         toast({
//           title: "Error",
//           description: "Failed to fetch service types",
//           status: "error",
//           duration: 3000,
//           isClosable: true,
//         });
//       }
//     };

//     getServiceTypes();
//   }, [selectedSubCategory]);

//   const refreshData = async () => {
//     const tkn = localStorage.getItem("token");
//     if (!tkn) {
//       toast({
//         title: "Error",
//         description: "Please login to continue",
//         status: "error",
//         duration: 3000,
//         isClosable: true,
//       });
//       return;
//     }

//     let url = `${process.env.REACT_APP_BASE_URL}/admin/service/getAllService`;

//     try {
//       const response = await axios.get(url, {
//         headers: {
//           Authorization: `${tkn}`,
//         },
//       });

//       setLinkedServicesData(response.data);

//       // Transform data for display
//       const transformedData = [];
//       for (const service of response.data) {
//         // If no case studies or filtering by service and this isn't the selected one
//         if (!service.caseStudy || service.caseStudy.length === 0) {
//           continue;
//         }

//         // Filter by main category if selected
//         if (
//           selectedMainCategory &&
//           service.mainCategory !== getMainCategoryNameById(selectedMainCategory)
//         ) {
//           continue;
//         }

//         // Filter by sub category if selected
//         if (
//           selectedSubCategory &&
//           service.subCategory !== getSubCategoryNameById(selectedSubCategory)
//         ) {
//           continue;
//         }

//         // Filter by service if selected
//         if (selectedServiceType && service._id !== selectedServiceType) {
//           continue;
//         }

//         // Add each case study as a row
//         for (const caseStudy of service.caseStudy) {
//           transformedData.push({
//             key: `${service._id}-${caseStudy._id}`,
//             serviceName: service.serviceName,
//             title: caseStudy.title,
//             mainCategory: service.mainCategory,
//             subCategory: caseStudy.subCategory || service.subCategory,
//             serviceId: service._id,
//             caseStudyId: caseStudy._id,
//             type: caseStudy.type,
//             image: caseStudy.imageURL
//               ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${caseStudy.imageURL}`
//               : null,
//           });
//         }
//       }

//       const filtered = searchQuery
//         ? transformedData.filter(search)
//         : transformedData;

//       setFilteredData(filtered);
//       setloading(false);
//     } catch (error: any) {
//       console.error("Error fetching services:", error);
//       setloading(false);
//       toast({
//         title: "Error",
//         description: "Failed to fetch service data.",
//         status: "error",
//         duration: 3000,
//         isClosable: true,
//         position: "top-right",
//       });
//     }
//   };
//   useEffect(() => {
//     refreshData();
//   }, [
//     searchQuery,
//     selectedMainCategory,
//     selectedSubCategory,
//     selectedServiceType,
//   ]);

//   const getMainCategoryNameById = (id: string) => {
//     const category = mainCategories.find((cat: any) => cat._id === id);
//     return category ? category.title : "";
//   };

//   const getSubCategoryNameById = (id: string) => {
//     const category = subCategories.find((cat: any) => cat._id === id);
//     return category ? category.title : "";
//   };

//   const handleSearch = (value: string) => {
//     setSearchQuery(value);
//   };

//   const handleDeleteCaseStudy = (serviceId: string, categoryId: string) => {
//     setTargetEvent({
//       serviceId: serviceId,
//       categoryId: categoryId,
//     });
//     onDeleteOpen();
//   };

//   const handleUnlinkCategory = async (
//     serviceId: string,
//     categoryId: string
//   ) => {
//     const tkn = localStorage.getItem("token");
//     if (!tkn) {
//       toast({
//         title: "Error",
//         description: "Please login to continue",
//         status: "error",
//         duration: 3000,
//         isClosable: true,
//       });
//       return;
//     }

//     try {
//       await axios.delete(
//         `${process.env.REACT_APP_BASE_URL}/admin/category/unlinkCategory?categoryId=${categoryId}&serviceId=${serviceId}`,
//         {
//           headers: {
//             Authorization: `${tkn}`,
//           },
//         }
//       );

//       toast({
//         title: "Success",
//         description: "Case study unlinked successfully",
//         status: "success",
//         duration: 3000,
//         isClosable: true,
//         position: "top-right",
//       });

//       // Refresh data after successful unlink
//       // refreshData();
//     } catch (error) {
//       console.error("Error unlinking case study:", error);
//       toast({
//         title: "Error",
//         description: "Failed to unlink case study",
//         status: "error",
//         duration: 3000,
//         isClosable: true,
//         position: "top-right",
//       });
//     }
//   };

//   const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
//     setSelectedRowKeys(newSelectedRowKeys);
//   };

//   const rowSelection = {
//     selectedRowKeys,
//     onChange: onSelectChange,
//   };

//   const columns = [
//     {
//       title: "Nos.",
//       dataIndex: "index",
//       width: 80,
//       render: (_: any, __: any, index: number) => `#${index + 1}`,
//     },
//     {
//       title: "Service Name",
//       dataIndex: "serviceName",
//       width: 200,
//     },
//     {
//       title: "Case Study",
//       dataIndex: "title",
//       width: 200,
//       render: (text: string, record: any) => (
//         <Flex align="center">
//           <Box
//             width="36px"
//             height="36px"
//             borderRadius="50%"
//             overflow="hidden"
//             backgroundColor="white"
//             marginRight="10px"
//             display="flex"
//             alignItems="center"
//             justifyContent="center"
//           >
//             {record.image ? (
//               <img
//                 src={record.image}
//                 alt={text}
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                 }}
//               />
//             ) : (
//               <Box
//                 width="100%"
//                 height="100%"
//                 bg="gray.200"
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="center"
//                 fontSize="xs"
//               >
//                 {text.charAt(0)}
//               </Box>
//             )}
//           </Box>
//           <Box>{text}</Box>
//         </Flex>
//       ),
//     },
//     {
//       title: "Main Category",
//       dataIndex: "mainCategory",
//       width: 150,
//     },
//     {
//       title: "Sub Category",
//       dataIndex: "subCategory",
//       width: 150,
//     },
//     {
//       title: "Action",
//       key: "actions",
//       width: 100,
//       render: (_: any, record: any) => (
//         <Space size="middle">
//           <RiDeleteBin6Line
//             style={{
//               color: "#ff4d4f",
//               cursor: "pointer",
//               height: "20px",
//               width: "20px",
//             }}
//             onClick={() =>
//               handleDeleteCaseStudy(record.serviceId, record.caseStudyId)
//             }
//           />
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <>
//       <div
//         style={{
//           width: "96vw",
//           maxWidth: "96vw",
//           maxHeight: "86vh",
//           height: "86vh",
//           top: "8vh ",
//           left: "4vw",
//           overflowY: "auto",
//           position: "relative",
//           backgroundColor: "#EEEEEE",
//           padding: "30px",
//         }}
//       >
//         <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//           <Flex w="full" alignItems="center" justifyContent="space-between">
//             <Box
//               display="flex"
//               alignItems="center"
//               bg="#FFF"
//               border="1px solid #b2b2b233"
//               borderRadius="12px"
//               w="400px"
//               padding="8px"
//             >
//               <Box
//                 pl={2}
//                 display="flex"
//                 alignItems="center"
//                 color="#9E9E9E"
//                 fontSize="2xl"
//               >
//                 <img
//                   src="/icons/searchlogo.svg"
//                   alt="searchlogo"
//                   style={{ height: "24px", width: "24px" }}
//                 />
//               </Box>

//               <Input
//                 id="search"
//                 type="text"
//                 placeholder="Search or type a command"
//                 onChange={(e) => handleSearch(e.target.value)}
//                 fontSize="sm"
//                 border="none"
//                 outline="none"
//                 color="#757575"
//                 _focus={{
//                   border: "none",
//                   outline: "none",
//                   boxShadow: "none",
//                 }}
//                 bg={"transparent"}
//                 style={{
//                   outline: "none",
//                   boxShadow: "none",
//                 }}
//               />
//             </Box>

//             <Spacer />

//             <Box
//               display={"flex"}
//               alignItems={"center"}
//               justifyContent={"flex-end"}
//               marginLeft="20px"
//             >
//               <Select
//                 placeholder="Main Category"
//                 value={selectedMainCategory}
//                 onChange={(e) => {
//                   const mainCategoryId = e.target.value;
//                   setSelectedMainCategory(mainCategoryId);
//                 }}
//                 bg="#FFF"
//                 marginRight="10px"
//               >
//                 {mainCategories.map((category: any) => (
//                   <option key={category._id} value={category._id}>
//                     {category.title}
//                   </option>
//                 ))}
//               </Select>
//               <Select
//                 placeholder="Sub-Category"
//                 value={selectedSubCategory}
//                 onChange={(e) => {
//                   const subCategoryId = e.target.value;
//                   setSelectedSubCategory(subCategoryId);
//                 }}
//                 bg="#FFF"
//                 isDisabled={!selectedMainCategory}
//                 marginRight="10px"
//               >
//                 {subCategories.map((subCategory: any) => (
//                   <option key={subCategory._id} value={subCategory._id}>
//                     {subCategory.title}
//                   </option>
//                 ))}
//               </Select>
//               <Select
//                 placeholder="Service"
//                 value={selectedServiceType}
//                 onChange={(e) => {
//                   const serviceId = e.target.value;
//                   setSelectedServiceType(serviceId);
//                 }}
//                 bg="#FFF"
//                 isDisabled={!selectedSubCategory}
//                 marginRight="10px"
//               >
//                 {serviceTypes.map((service: any) => (
//                   <option key={service._id} value={service._id}>
//                     {service.title}
//                   </option>
//                 ))}
//               </Select>
//             </Box>
//           </Flex>

//           <Spacer></Spacer>

//           <Table
//             rowSelection={rowSelection}
//             columns={columns}
//             dataSource={filteredData}
//             scroll={{ x: "max-content" }}
//             size="middle"
//             loading={loading}
//             style={{
//               backgroundColor: "white",
//               borderRadius: 6,
//             }}
//             pagination={{
//               position: ["bottomRight"],
//               pageSize: 10,
//             }}
//           />
//         </div>
//       </div>
//       {isDeleteOpen && targetevent && (
//         <CasestudyDeleteConfirmation
//           isOpen
//           bannerData={targetevent}
//           onDeleteClose={onDeleteClose}
//           refreshData={() => {
//             handleUnlinkCategory(targetevent.serviceId, targetevent.categoryId);
//             onDeleteClose();
//           }}
//         />
//       )}
//     </>
//   );
// };

// export default FilterCasestudyByLinkedTable;
import {
  Box,
  Flex,
  Input,
  Select,
  Spacer,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { Space, Table } from "antd";
import axios from "axios";
import { get } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useDispatch } from "react-redux";
import CasestudyDeleteConfirmation from "../modals/CasestudyDeleteConfirmation";
import CasestudyUnlinkedConfirmation from "../modals/CasestudyUnlinkedConfirmation";

interface Props {
  query: string;
}

const FilterCasestudyByLinkedTable: React.FC<Props> = ({ query }) => {
  const toast = useToast();
  const dispatch = useDispatch();
  const searchColumns = useMemo(() => ["serviceName", "title"], []);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [groupedData, setGroupedData] = useState<any[]>([]);
  const [categoryFilter, setCategoryFilter] = useState<string>("All");
  const [targetevent, setTargetEvent] = useState<any>();
  const [loading, setloading] = useState(true);
  const [mainCategories, setMainCategories] = useState<any>([]);
  const [subCategories, setSubCategories] = useState<any>([]);
  const [serviceTypes, setServiceTypes] = useState<any>([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState<string>("");
  const [selectedSubCategory, setSelectedSubCategory] = useState<string>("");
  const [selectedServiceType, setSelectedServiceType] = useState<string>("");
  const [linkedServicesData, setLinkedServicesData] = useState<any[]>([]);

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const search = (item: Record<string, any>) => {
    // Check if service name matches search query
    if (item.serviceName?.toLowerCase().includes(searchQuery.toLowerCase())) {
      return true;
    }

    // Check if any case study title matches search query
    if (item.caseStudies && Array.isArray(item.caseStudies)) {
      return item.caseStudies.some((cs: any) =>
        cs.title?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    return false;
  };

  useEffect(() => {
    const getMainCategories = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/mainCategory`
        );
        setMainCategories(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    getMainCategories();
  }, []);

  useEffect(() => {
    const getSubCategories = async () => {
      if (!selectedMainCategory) {
        setSubCategories([]);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/subCategory?mainCategoryId=${selectedMainCategory}`
        );
        setSubCategories(response.data);
        setSelectedSubCategory("");
        setSelectedServiceType("");
        setServiceTypes([]);
      } catch (error) {
        console.log(error);
        toast({
          title: "Error",
          description: "Failed to fetch subcategories",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    getSubCategories();
  }, [selectedMainCategory]);

  useEffect(() => {
    const getServiceTypes = async () => {
      if (!selectedSubCategory) {
        setServiceTypes([]);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/service?subCategoryId=${selectedSubCategory}`
        );
        setServiceTypes(response.data);
        setSelectedServiceType("");
      } catch (error) {
        console.log(error);
        toast({
          title: "Error",
          description: "Failed to fetch service types",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    getServiceTypes();
  }, [selectedSubCategory]);

  const refreshData = async () => {
    const tkn = localStorage.getItem("token");
    if (!tkn) {
      toast({
        title: "Error",
        description: "Please login to continue",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setloading(true);
    let url = `${process.env.REACT_APP_BASE_URL}/admin/service/getAllService`;

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `${tkn}`,
        },
      });

      setLinkedServicesData(response.data);

      // Group data by service
      const serviceMap = new Map();

      for (const service of response.data) {
        // Skip services without case studies
        if (!service.caseStudy || service.caseStudy.length === 0) {
          continue;
        }

        // Filter by main category if selected
        if (
          selectedMainCategory &&
          service.mainCategory !== getMainCategoryNameById(selectedMainCategory)
        ) {
          continue;
        }

        // Filter by sub category if selected
        if (
          selectedSubCategory &&
          service.subCategory !== getSubCategoryNameById(selectedSubCategory)
        ) {
          continue;
        }

        // Filter by service if selected
        if (selectedServiceType && service._id !== selectedServiceType) {
          continue;
        }

        // Transform case studies for this service
        const caseStudies = service.caseStudy.map((cs: any) => ({
          title: cs.title,
          caseStudyId: cs._id,
          type: cs.type,
          subCategory: cs.subCategory,
          image: cs.imageURL
            ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${cs.imageURL}`
            : null,
        }));

        // Add to the grouped data
        serviceMap.set(service._id, {
          key: service._id,
          serviceName: service.serviceName,
          mainCategory: caseStudies.type,
          subCategory: caseStudies.subCategory,
          serviceId: service._id,
          caseStudies: caseStudies,
        });
      }

      // Convert map to array
      const groupedDataArray = Array.from(serviceMap.values());

      // Apply search filter if needed
      const filteredGroupedData = searchQuery
        ? groupedDataArray.filter(search)
        : groupedDataArray;

      // Add index numbers
      const indexedData = filteredGroupedData.map((item, index) => ({
        ...item,
        index: index + 1,
      }));

      setGroupedData(indexedData);
      setloading(false);
    } catch (error: any) {
      console.error("Error fetching services:", error);
      setloading(false);
      toast({
        title: "Error",
        description: "Failed to fetch service data.",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  useEffect(() => {
    refreshData();
  }, [
    searchQuery,
    selectedMainCategory,
    selectedSubCategory,
    selectedServiceType,
  ]);

  const getMainCategoryNameById = (id: string) => {
    const category = mainCategories.find((cat: any) => cat._id === id);
    return category ? category.title : "";
  };

  const getSubCategoryNameById = (id: string) => {
    const category = subCategories.find((cat: any) => cat._id === id);
    return category ? category.title : "";
  };

  const handleSearch = (value: string) => {
    setSearchQuery(value);
  };

  const handleDeleteCaseStudy = (serviceId: string, caseStudyId: string) => {
    setTargetEvent({
      serviceId: serviceId,
      categoryId: caseStudyId,
    });
    onDeleteOpen();
  };

  const handleUnlinkCategory = async (
    serviceId: string,
    categoryId: string
  ) => {
    const tkn = localStorage.getItem("token");
    if (!tkn) {
      toast({
        title: "Error",
        description: "Please login to continue",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/admin/category/unlinkCategory?categoryId=${categoryId}&serviceId=${serviceId}`,
        {
          headers: {
            Authorization: `${tkn}`,
          },
        }
      );

      toast({
        title: "Success",
        description: "Case study unlinked successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });

      refreshData();
    } catch (error) {
      console.error("Error unlinking case study:", error);
      toast({
        title: "Error",
        description: "Failed to unlink case study",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // Render a single case study item
  const renderCaseStudyItem = (caseStudy: any, serviceId: string) => (
    <Flex
      key={caseStudy.caseStudyId}
      align="center"
      bg="gray.50"
      p={2}
      borderRadius="md"
      mb={2}
    >
      <Box
        width="36px"
        height="36px"
        borderRadius="50%"
        overflow="hidden"
        backgroundColor="white"
        marginRight="10px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {caseStudy.image ? (
          <img
            src={caseStudy.image}
            alt={caseStudy.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <Box
            width="100%"
            height="100%"
            bg="gray.200"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="xs"
          >
            {caseStudy.title.charAt(0)}
          </Box>
        )}
      </Box>
      <Box flex="1">{caseStudy.title}</Box>
      <Box flex="1">{caseStudy.type}</Box>
      <Box flex="1">{caseStudy.subCategory}</Box>
      <Box>
        <RiDeleteBin6Line
          style={{
            color: "#ff4d4f",
            cursor: "pointer",
            height: "18px",
            width: "18px",
          }}
          onClick={() =>
            handleDeleteCaseStudy(serviceId, caseStudy.caseStudyId)
          }
        />
      </Box>
    </Flex>
  );

  const columns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 70,
      render: (index: number) => `#${index}`,
    },
    // {
    //   title: "Main Category",
    //   dataIndex: "caseStudies",
    //   width: 150,
    //   render: (caseStudies: any[]) => {
    //     const mainCategory = caseStudies[0]?.type;
    //     return mainCategory ? mainCategory : "N/A";
    //   },
    // },
    // {
    //   title: "Sub Category",
    //   dataIndex: "caseStudies",
    //   width: 150,
    //   render: (caseStudies: any[]) => {
    //     const subCategory = caseStudies[0]?.subCategory;
    //     return subCategory ? subCategory : "N/A";
    //   },
    // },
    {
      title: "Service Name",
      dataIndex: "serviceName",
      width: 180,
    },
    {
      title: "Case Study",
      dataIndex: "caseStudies",
      width: 350,
      render: (caseStudies: any[], record: any) => (
        <Box maxHeight="300px" overflowY="auto" px={1}>
          {caseStudies.map((cs) => renderCaseStudyItem(cs, record.serviceId))}
        </Box>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh ",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Flex w="full" alignItems="center" justifyContent="space-between">
            <Box
              display="flex"
              alignItems="center"
              bg="#FFF"
              border="1px solid #b2b2b233"
              borderRadius="12px"
              w="400px"
              padding="8px"
            >
              <Box
                pl={2}
                display="flex"
                alignItems="center"
                color="#9E9E9E"
                fontSize="2xl"
              >
                <img
                  src="/icons/searchlogo.svg"
                  alt="searchlogo"
                  style={{ height: "24px", width: "24px" }}
                />
              </Box>

              <Input
                id="search"
                type="text"
                placeholder="Search or type a command"
                onChange={(e: any) => handleSearch(e.target.value)}
                fontSize="sm"
                border="none"
                outline="none"
                color="#757575"
                _focus={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                }}
                bg={"transparent"}
                style={{
                  outline: "none",
                  boxShadow: "none",
                }}
              />
            </Box>

            <Spacer />

            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"flex-end"}
              marginLeft="20px"
            >
              <Select
                placeholder="Main Category"
                value={selectedMainCategory}
                onChange={(e: any) => {
                  const mainCategoryId = e.target.value;
                  setSelectedMainCategory(mainCategoryId);
                }}
                bg="#FFF"
                marginRight="10px"
              >
                {mainCategories.map((category: any) => (
                  <option key={category._id} value={category._id}>
                    {category.title}
                  </option>
                ))}
              </Select>
              <Select
                placeholder="Sub-Category"
                value={selectedSubCategory}
                onChange={(e: any) => {
                  const subCategoryId = e.target.value;
                  setSelectedSubCategory(subCategoryId);
                }}
                bg="#FFF"
                isDisabled={!selectedMainCategory}
                marginRight="10px"
              >
                {subCategories.map((subCategory: any) => (
                  <option key={subCategory._id} value={subCategory._id}>
                    {subCategory.title}
                  </option>
                ))}
              </Select>
              <Select
                placeholder="Service"
                value={selectedServiceType}
                onChange={(e: any) => {
                  const serviceId = e.target.value;
                  setSelectedServiceType(serviceId);
                }}
                bg="#FFF"
                isDisabled={!selectedSubCategory}
                marginRight="10px"
              >
                {serviceTypes.map((service: any) => (
                  <option key={service._id} value={service._id}>
                    {service.title}
                  </option>
                ))}
              </Select>
            </Box>
          </Flex>

          <Spacer></Spacer>

          <Table
            rowClassName={() => "no-hover"}
            // rowSelection={rowSelection}
            columns={columns}
            dataSource={groupedData}
            scroll={{ x: "max-content" }}
            size="middle"
            loading={loading}
            style={{
              backgroundColor: "white",
              borderRadius: 6,
            }}
            pagination={{
              position: ["bottomRight"],
              pageSize: 10,
            }}
          />
        </div>
      </div>
      {isDeleteOpen && targetevent && (
        <CasestudyUnlinkedConfirmation
          isOpen
          bannerData={targetevent}
          onDeleteClose={onDeleteClose}
          refreshData={() => {
            handleUnlinkCategory(targetevent.serviceId, targetevent.categoryId);
            onDeleteClose();
          }}
        />
      )}
    </>
  );
};

export default FilterCasestudyByLinkedTable;
